import PopupActions from '../../../actions/PopupActions';
import PopupStore from '../../../stores/PopupStore';
import { endPoints as PosEndPoints } from '../../../constants/PosConstants';
import NotificationActions from '../../../actions/NotificationActions';
import UserStore from '../../../stores/UserStore';
import AjaxPromises from '../../../utils/AjaxPromises';

class BypassStateSystem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            managerPin: null,
            guest: this.props.guest,
            shipmentId: this.props.shipmentId,
            loading: false,
        };

        this.bypass = this.bypass.bind(this);
        this.canBypass = this.canBypass.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    async bypass() {
        if (!this.canBypass() || this.state.loading) {
            return;
        } else {
            await this.setState({ loading : true }, () => {
                AjaxPromises.POST(PosEndPoints.BYPASS_STATE_SYSTEM, UserStore.getApiData({
                    ShipmentId: this.state.shipmentId,
                    ManagerPIN: this.state.managerPin,
                })).then(res => {
                    this.setState({ loading : false });
                    if (res.Result) {
                        NotificationActions.success('Delivery bypassed.');
                        PopupActions.close();
                        PopupActions.openDelivery(this.state.guest, this.state.shipmentId);
                        this.setState({
                            guest : false,
                            shipmentId : false
                        });
                    } else {
                        NotificationActions.error(`Bypass failed: ${res.Message}`);
                    }
                })
            })
        }
    }

    canBypass() {
        return !!this.state.managerPin;
    }

    async cancel() {
        await PopupActions.close();
        await PopupActions.openDelivery(this.state.guest, this.state.shipmentId);
        this.setState({
            guest : false,
            shipmentId : false
        });
    }

    render() {
        return (
            <div
                className={'popup popup__transparent'} style={{ zIndex: 7 }}>

                <div className='popup__content' style={{height: 300 }}>

                    <div className='popup-header'>
                        Bypass State System

                        <div
                            className='popup-close'
                            onClick={this.cancel}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <div className='delivery-options' style={{ height: 260 }}>
                        <div className='delivery-options__label'>
                            Manager PIN
                        </div>

                        <input
                            type='password'
                            placeholder='Manager PIN'
                            value={this.state.managerPin}
                            onChange={(e) => { this.setState({ managerPin : e.target.value }); }}
                        />
                        <div style={{ height: 50, marginTop: 10 }}>
                            <div
                                className={'btn-green delivery-options__save '+(!this.canBypass() ? 'btn-green__disabled' : '')}
                                onClick={this.bypass}
                                style={{ position: 'absolute', left: 0}}                            
                            >
                                Bypass
                            </div>
                            <div
                                className={'btn-green delivery-options__save pull-right'}
                                onClick={this.cancel}
                                style={{ position: 'absolute', right: 20}}
                            >
                                Cancel
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BypassStateSystem;
        


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/delivery/BypassStateSystem.react.jsx